export default "__VITE_ASSET__Bkf$Jp0R__"